export type CardType =
  | "text"
  | "image"
  | "critical"
  | "trend"
  | "progress"
  | "anomaly"
  | "sentiment"
  | "geo"
  | "histogram"
  | "treemap"
  | "heatmap"
  | "location"
  | "wordCloud"
  | "bsc";

export type InsightCard = {
  id: string;
  type: CardType;
  title: string;
  props?: Record<string, any>;
};

// + këto fusha te HeaderOptions
export type HeaderOptions = {
  titleColor?: string;
  subtitleColor?: string;

  fontSize?: number;
  fontFamily?: string;

  paddingLeft?: number | string;
  paddingRight?: number | string;

  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
  radius?: number;

  logoUrl?: string;
  logoAlign?: string;
  lineHeight?: number | string;
  headerImageUrl?: string;
  headerImageAlign?: string;
  headerImageWidth?: number | string;
  headerImageRadius?: number;
  headerImageDataUrl?: string;
};

export type FooterOptions = {
  textColor: string;
  fontSize: number;
  fontFamily: string;
  paddingX: number;
  paddingY: number;
  backgroundColor: string;
  borderColor: string;
  borderWidth: number;
  radius: number;

  lineHeight?: number | string;
  paddingLeft?: number;
  paddingRight?: number;

  imageUrl?: string;
  imageAlign?: "left" | "right";
};
// DEFAULT_HEADER – shto defaults
export const DEFAULT_HEADER: HeaderOptions = {
  titleColor: "#FFFFFF",
  subtitleColor: "#EAE7FF",
  fontSize: 20,
  fontFamily: "Poppins",
  paddingLeft: 16,
  paddingRight: 16,
  backgroundColor: "#A072EB",
  radius: 12,
  borderColor: "#A072EB",
  borderWidth: 0,

  logoAlign: "right",

  headerImageAlign: "right",
};

export const DEFAULT_FOOTER: FooterOptions = {
  textColor: "#666666",
  fontSize: 12,
  fontFamily: "Poppins",
  paddingX: 24,
  paddingY: 12,
  backgroundColor: "#F5F5F5",
  borderColor: "#D9D9D9",
  borderWidth: 0,
  radius: 12,

  lineHeight: "normal",
  paddingLeft: 24,
  paddingRight: 24,

  imageUrl: "",
  imageAlign: "right",
};

// export const LS_KEY = "dashboard-template-state-v2";
